import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FontsService, Font } from '../../../services/fonts.service';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-twitter',
	templateUrl: './twitter.component.html',
	styleUrls: ['./twitter.component.scss']
})
export class TwitterComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('twitterForm', { static: true }) twitterForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	twitterFormSubscription: Subscription;
	defaultChanged = false;

	isAdmin;
	background_type;
	font;
	templateFont;
	speed;
	fonts: Array<Font>;
	templateFonts: Array<Font>;

	constructor(private comService: ComponentService, private fontsService: FontsService, private auth: AuthService) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();

		if (this.componentData.config.version > 1) {
			this.componentData.config.retweet = this.componentData.config.retweet ? this.componentData.config.retweet : false;

			this.templateFonts = [...this.fontsService.getFonts()];
			this.templateFont =
				this.fontsService.getFontsArray().indexOf(this.componentData.config.template.font_url) === -1
					? 'Custom Font'
					: this.componentData.config.template.font_url;
		}

		this.background_type = this.componentData.config.background['background-image'] ? 'Image' : 'Color';

		this.fonts = this.fontsService.getFonts();

		this.font =
			this.fontsService.getFontsArray().indexOf(this.componentData.config.text.font) === -1
				? 'Custom Font'
				: this.componentData.config.text.font;

		this.speed = this.componentData.config.total_duration / this.componentData.config.count;

		this.twitterFormSubscription = this.twitterForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.twitterForm.dirty && this.twitterForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.twitterForm.dirty && this.twitterForm.valid),
				debounceTime(2000)
			)
			.subscribe((data) => {
				//    this.brodcastToPreview()
				this.defaultChanged = true;
			});
	}

	ngOnDestroy() {
		this.twitterFormSubscription.unsubscribe();
	}

	resetBackground(type) {
		if (type == 'color') {
			this.componentData.config.background['base-background-image'] = this.componentData.config.background['background-image'];
			this.componentData.config.background['background-image'] = '';
		} else {
			this.componentData.config.background['background-image'] = this.componentData.config.background['base-background-image'];
		}
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	onImageChange(event) {
		const configWidth: number =
			this.componentData &&
			this.componentData.config &&
			this.componentData.config.background &&
			this.componentData.config.background['width'];

		const configHeight: number =
			this.componentData &&
			this.componentData.config &&
			this.componentData.config.background &&
			this.componentData.config.background['height'];

		const u = String(event && event.url);
		const w = Number(event && event.width ? event.width : configWidth);
		const h = Number(event && event.height ? event.height : configHeight);

		this.componentData.config.background['background-image'] = u;
		this.componentData.config.background['width'] = w;
		this.componentData.config.background['height'] = h;
	}

	customTemplateChange() {
		if (this.componentData.config.template.custom_template) {
			this.componentData.config.template.template_url = this.componentData.config.template.template_url
				? this.componentData.config.template.template_url
				: '';
			this.componentData.config.template.font_url = this.componentData.config.template.font_url
				? this.componentData.config.template.font_url
				: '';
			this.componentData.config.template.tweet_token = this.componentData.config.template.tweet_token
				? this.componentData.config.template.tweet_token
				: '%%tweet%%';
		}
	}
}
